var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paymentLoading)?_c('div',[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }